import { Auth0Provider, AppState } from "@auth0/auth0-react";
import React, { PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";

interface Auth0ProviderWithNavigateProps {
  children: React.ReactNode;
}

export const Auth0ProviderWithNavigate = ({
  children,
}: PropsWithChildren<Auth0ProviderWithNavigateProps>): JSX.Element | null => {
  const navigate = useNavigate();

  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_AUTH0_CALLBACK_URL;

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  // if (!(domain && clientId && redirectUri)) {
  //   alert(
  //     "Missing configuration for Auth0Provider. Please check .env file and make sure it has REACT_APP_AUTH0_DOMAIN, REACT_APP_AUTH0_CLIENT_ID, and REACT_APP_AUTH0_CALLBACK_URL."
  //   );
  //   return null;
  // }

  return (
    // <Auth0Provider
    //   domain={domain}
    //   clientId={clientId}
    //   authorizationParams={{
    //     redirect_uri: redirectUri,
    //     audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    //   }}
    //   onRedirectCallback={onRedirectCallback}
    // >
    <>{children}</>
    // </Auth0Provider>
  );
};
